<template>
  <div id="header">
    <div class="bg" :class="{loading: !startupQuantity}" />
    <img
      alt="login-bg"
      src="../assets/images/x-bg.png"
      class="x-bg d-block d-md-none"
      :class="{loading: !startupQuantity}"
    />
    <div class="container rel">
      <img
        alt="login-bg"
        src="../assets/images/x-bg.png"
        class="x-bg d-none d-md-block"
        :class="{loading: !startupQuantity}"
      />
      <SecondaryButton @click="quit" class="quit-button">Salir</SecondaryButton>
      <div class="row" style="align-items:center;flex-wrap:nowrap;">
        <GridxLogo class="logo" />
        <div class="fondos" v-if="$store.state.showFondosBar">
          <button 
            @click="selectFondo('GRIDX')" 
            :class="{active: selectedFondo === 'GRIDX'}"
          >Fund I</button>
          <button 
            @click="selectFondo('GRIDX2')" 
            :class="{active: selectedFondo === 'GRIDX2'}"
          >Fund II</button>
        </div>
      </div>
      <transition name="slide-fade">
        <div
          class="col-12 col-md-10 offset-md-1 numbers-box"
          v-if="startupQuantity"
        >
          <div class="row">
            <div class="col-9 col-md-10">
              <div class="row">
                <div class="col-6 col-md-2 p-0">
                  <div class="header-item">
                    <div class="block-container">
                      <h3>{{sigfig(totalValuation)}}</h3>
                      <p>Valuación total (U$D)</p>
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-3 p-0">
                  <div class="header-item">
                    <div class="block-container">
                      <h3>{{sigfig(portfolioValuation)}}</h3>
                      <p>Valuación portfolio (U$D)</p>
                    </div>
                  </div>
                </div>
                <div class="col-2 col-md-1 p-0">
                  <div class="header-item alt">
                    <div class="block-container">
                      <h3>{{startupQuantity}}</h3>
                      <p>Startups</p>
                    </div>
                  </div>
                </div>
                <div class="col-2 col-md-1 p-0">
                  <div class="header-item alt">
                    <div class="block-container">
                      <h3>{{totalEmployees}}</h3>
                      <p>RRHH</p>
                    </div>
                  </div>
                </div>
                <div class="col-4 col-md-3 p-0">
                  <div class="header-item alt">
                    <div class="block-container">
                      <h3>{{sigfig(totalInvested)}}</h3>
                      <p>Total {{fund}} <br class="d-block d-md-none">(U$D)</p>
                    </div>
                  </div>
                </div>
                <div class="col-4 col-md-2 p-0">
                  <div class="header-item alt">
                    <div class="block-container">
                      <h3>{{sigfig(totalExternalInvested)}}</h3>
                      <p>Total inv. externa <br class="d-block d-md-none">(U$D)</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-3 col-md-2 pr-0 pl-1">
              <a href="#" @click="openPanel($event)" class="docs-fidei" v-show="false">
                <div class="header-item item-fideicomiso">
                  <div class="block-container">
                    <GridxX class="file-icon" />
                    <p>
                      Documentos
                      <br />Fideicomiso
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import GridxLogo from '../assets/icons/gridx-logo.svg';
import SecondaryButton from './Button/SecondaryButton.vue';
import GridxX from '../assets/icons/gridx-x.svg';
import { sigfig } from '../helpers/numbers';

export default {
  name: 'Header',
  props: {
    totalValuation: Number,
    portfolioValuation: Number,
    startupQuantity: Number,
    totalInvested: Number,
    totalEmployees: Number,
    totalExternalInvested: Number,
    openSidepanel: Function,
  },
  components: {
    GridxLogo,
    SecondaryButton,
    GridxX,
  },
  computed: {
    selectedFondo() {
      return this.$store.state.selectedFondo;
    },
    fund() {
      if(this.selectedFondo === 'GRIDX2') return 'Fund II';
      return 'Fund I'; 
    }
  },
  data() {
    return {
      sigfig,
    };
  },
  methods: {
    quit() {
      this.$router.push({ name: 'Login' });
    },
    openPanel($event){
      $event.preventDefault();
      this.openSidepanel(true);
    },
    selectFondo(val) {
      this.$store.commit('selectFondo', val);
    }
  },
};
</script>

<style scoped lang="scss">
#header {
  width: 100%;
}

.rel {
  position: relative;
}

.x-bg {
  position: absolute;
  right: -34px;
  top: 83px;
  width: 386px;
  opacity: 0.9;
  transition: 0.5s ease-in-out opacity;
  transition-delay: 0.2s;

  &.loading {
    opacity: 0;
  }

  @media (min-width: 768px) {
    right: 8px;
    top: 37px;
  }
}

.quit-button {
  float: right;
  text-align: right;
  transform: translate(22px, 28px);
}

.block-container {
  display: block;
  margin: 0 auto;
  width: fit-content;
  margin-top: 10px;
}

.header-item {
  padding-top: 10px;

  @media (min-width: 768px) {
    background: transparent;
    border-radius: 8px;
    padding-top: 20px;
    padding-bottom: 10px;
  }

  &.item-fideicomiso {
    background: #fff;
    padding-bottom: 10px;
    max-width: 95px;
    border-radius: 4px;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.15);
    margin: 0 auto;
    margin-top: 30px;

    @media (min-width: 768px) {
      margin-top: 5px;
    }
  }

  &.alt {
    h3 {
      color: #330e2f;
      font-size: 16px;

      @media (min-width: 768px) {
        font-size: 24px;
        color: #fff;
      }
    }

    p {
      color: #979797;

      @media (min-width: 768px) {
        color: #fff;
      }
    }
  }

  h3 {
    height: 25px;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    color: #fff;
    margin: 0;

    @media (min-width: 341px) {
      font-size: 23px;
    }

    @media (min-width: 768px) {
      text-align: center;
      font-size: 24px;
    }

    span {
      font-size: 10px;
    }
  }

  p {
    font-size: 9px;
    color: #e5e5e5;
    line-height: 12px;
    margin-top: 0;

    @media (min-width: 768px) {
      font-size: 10px;
    }
  }
}
.logo {
  position: relative;
  float: left;
  margin-top: 30px;
  margin-left: 15px;
  height: 29px;
}
.fondos {
  margin-top: 30px;
  width: 100%;
  display: flex;
  justify-content: flex-end;

  @media (min-width: 768px) {
    justify-content: center;
  }
}
.bg {
  width: 100%;
  height: 193px;
  background: #330e2f;
  border-radius: 0px 0px 30px 30px;
  position: absolute;
  top: 0;
  left: 0;
  transition: 0.3s height ease;

  &.loading {
    height: 85px;
  }

  @media (min-width: 768px) {
    height: 164px;
    border-radius: 0;
  }
}
.numbers-box {
  background: transparent;
  border-radius: 8px;
  margin-top: 50px;
  padding: 10px 15px;

  @media (min-width: 768px) {
    margin-top: 5px;
  }

  @media (min-width: 992px) {
    margin-top: 12px;
  }
}
.file-icon {
  width: 19px;
  height: 17px;
  margin: 0 auto;
  display: block;
  margin-top: 5px;
  margin-bottom: 5px;
  position: relative;
  left: 1px;
}
.docs-fidei p {
  text-align: center;
  color: #ff5f3c;
  font-weight: 600;
}
.fondos{
  button {
    font-weight: 700;
    font-size: 14px;
    line-height: 22px;
    color: #FFFFFF;
    border: none;
    background: transparent;
    cursor: pointer;
    margin-right: 12px;
    border-bottom: 2px solid transparent;

    @media (min-width: 768px) {
      font-size: 18px;
      margin-right: 60px;
    }

    &.active, &:hover {
      border-bottom: 2px solid #FF5F3C;
    }
  }
}
</style>
